// Minimal stroke icon set for the UserPanel page.
// Every icon shares the same 24x24 viewBox, stroke width, and alignment so
// all menu/action rows stay visually consistent. Icons inherit `currentColor`
// — no new theme colors are introduced.

function BaseIcon({ children, size = 22 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {children}
    </svg>
  );
}

// Default profile avatar shown when the user has no profile image.
export function DefaultAvatarIcon({ size = 44 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="12" cy="8" r="3.6" />
      <path d="M4.5 19.5c1.4-3.4 4.2-5 7.5-5s6.1 1.6 7.5 5" />
    </svg>
  );
}

// User information card / identity menu icon.
export function IdCardIcon({ size } = {}) {
  return (
    <BaseIcon size={size}>
      <rect x="3" y="5" width="18" height="14" rx="2.5" />
      <circle cx="8.5" cy="11" r="2" />
      <path d="M5.8 16.2c.6-1.4 1.6-2 2.7-2s2.1.6 2.7 2" />
      <path d="M14 9.5h4M14 13h4" />
    </BaseIcon>
  );
}

// Mechanic / service registration menu icon.
export function WrenchIcon({ size } = {}) {
  return (
    <BaseIcon size={size}>
      <path d="M14.5 6.5a4 4 0 0 0-5.6 4.8L4 16.2V20h3.8l4.9-4.9a4 4 0 0 0 4.8-5.6l-2.7 2.7-2.5-.6-.6-2.5 2.8-2.6Z" />
    </BaseIcon>
  );
}

// Comments / suggestions menu icon.
export function ChatIcon({ size } = {}) {
  return (
    <BaseIcon size={size}>
      <path d="M4 6.5A2.5 2.5 0 0 1 6.5 4h11A2.5 2.5 0 0 1 20 6.5v7a2.5 2.5 0 0 1-2.5 2.5H9l-5 4v-13Z" />
      <path d="M8.5 9.5h7M8.5 12.5h4.5" />
    </BaseIcon>
  );
}

// Support menu icon.
export function SupportIcon({ size } = {}) {
  return (
    <BaseIcon size={size}>
      <path d="M4.5 12a7.5 7.5 0 0 1 15 0" />
      <rect x="3" y="11" width="4" height="6" rx="1.5" />
      <rect x="17" y="11" width="4" height="6" rx="1.5" />
      <path d="M19 17a4 4 0 0 1-4 3h-2" />
    </BaseIcon>
  );
}

// Back-to-dashboard / home menu icon.
export function HomeIcon({ size } = {}) {
  return (
    <BaseIcon size={size}>
      <path d="M4 11.5 12 4.5l8 7" />
      <path d="M6.5 10v9.5h11V10" />
    </BaseIcon>
  );
}

// Edit (pencil) action icon.
export function EditIcon({ size } = {}) {
  return (
    <BaseIcon size={size}>
      <path d="M4 20h4l11-11a2.1 2.1 0 0 0-4-4L4 16v4Z" />
      <path d="m13.5 6.5 4 4" />
    </BaseIcon>
  );
}

// Camera / upload image action icon.
export function CameraIcon({ size } = {}) {
  return (
    <BaseIcon size={size}>
      <path d="M4 8h3l2-2.5h6L17 8h3a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1Z" />
      <circle cx="12" cy="13.5" r="3.2" />
    </BaseIcon>
  );
}

// Delete / remove image action icon.
export function TrashIcon({ size } = {}) {
  return (
    <BaseIcon size={size}>
      <path d="M4.5 6.5h15M9.5 6V4.8A.8.8 0 0 1 10.3 4h3.4a.8.8 0 0 1 .8.8V6" />
      <path d="M6.5 6.5 7.3 19a1 1 0 0 0 1 1h7.4a1 1 0 0 0 1-1l.8-12.5" />
      <path d="M10 10.5v6M14 10.5v6" />
    </BaseIcon>
  );
}

// Logout / exit account action icon.
export function LogoutIcon({ size } = {}) {
  return (
    <BaseIcon size={size}>
      <path d="M14 4h4.5A1.5 1.5 0 0 1 20 5.5v13a1.5 1.5 0 0 1-1.5 1.5H14" />
      <path d="M10 8l-4 4 4 4" />
      <path d="M6 12h9" />
    </BaseIcon>
  );
}
